import { Decimal } from "decimal.js-light";
import { COMPANY_CURRENCY, DEFAULT_CURRENCY_DECIMALS } from "./constants";

export const roundTo = (number, numberOfDecimals) => {
  const float = new Decimal(number);
  return parseFloat(float.toFixed(numberOfDecimals));
};

export const roundToTwoDecimals = (number) => {
  return roundTo(number, 2);
};

export const isInteger = (string) => {
  return /^\d+$/.test(string);
};

export const bitsToMegabytes = (bits) => {
  return Math.round(bits / 1048576);
};

export const isSameSign = (number1, number2) => Math.sign(number1) === Math.sign(number2);

export const amountFormatted = (amount, currencySymbol) => {
  return `${amount.toLocaleString("fr")} ${currencySymbol}`;
};

export const numberToCurrency = (number, options = {}) => {
  const decimals = options.decimals ?? DEFAULT_CURRENCY_DECIMALS;
  const currency = options.currency || COMPANY_CURRENCY;

  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: currency,
    currencyDisplay: "symbol",
    maximumFractionDigits: decimals,
    minimumFractionDigits: decimals,
  }).format(number);
};

export const currencyToNumber = (amountWithCurrency) => {
  return amountWithCurrency.replace(/\s/g, "").replace(",", ".").replace("€", "");
};

export const sum = (targets) => {
  return targets.reduce((acc, target) => {
    let value = +target.value;
    if (!value) {
      value = 0;
    }
    return parseFloat(value) + acc;
  }, 0);
};

export const isAmount = (string) => {
  return /^-?\d+\.?\d*$/.test(string);
};

export const numericRange = (min, max, exact) => {
  if (isAmount(exact)) {
    return [exact];
  }

  if (isAmount(min)) {
    if (isAmount(max)) {
      return [min, max];
    } else {
      return [min, Number.MAX_SAFE_INTEGER];
    }
  } else if (isAmount(max)) {
    return [-Number.MAX_SAFE_INTEGER, max];
  }
};

export const isNumberInRange = (min, max, number) => {
  return number >= min && number <= max;
};

export const signedValue = (isPositive, value) => {
  return isPositive ? value : -value;
};

export const nonNegative = (value) => {
  if (!value) {
    return 0;
  }
  return Math.max(0, value);
};
